import React from 'react';
import { Link } from 'react-router-dom';
import { getAllCatalogs } from '../../services/poetryService';
import {xCycles, xPoets} from "../../utils/Lang";

const CatalogPage: React.FC = () => {
  const catalogs = getAllCatalogs();

  return (
    <div className="catalog-page">
      <h1 className="catalog-page__title">Каталог</h1>

      <ul className="catalog-list__items">
        {catalogs.map(catalog => (
          <li key={catalog.id}>
            <Link to={`/catalog/${catalog.id}`} className="catalog-list__item">
              {catalog.name}
              <span className="catalog-list__item-count">
                ({catalog.poets.length} {catalog.type === "cycles" ? xCycles(catalog.poets.length) : xPoets(catalog.poets.length)})
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CatalogPage;

